/** How many workflows the sidebar lists before "All workflows". */
export const NAV_WORKFLOW_CAP = 6;

/**
 * Pinned first, then recently opened, then the current one — up to the cap,
 * plus the current one even past it — kept in the list's own order.
 */
export function capWorkflows<T extends { id: string; key: string }>(
  ordered: readonly T[],
  {
    pinnedIds,
    recentKeys,
    currentKey,
  }: {
    pinnedIds: readonly string[];
    recentKeys: readonly string[];
    currentKey?: string;
  },
): T[] {
  const chosen = new Set<string>();
  for (const w of ordered) {
    if (chosen.size >= NAV_WORKFLOW_CAP) break;
    if (pinnedIds.includes(w.id)) chosen.add(w.id);
  }
  for (const key of recentKeys) {
    if (chosen.size >= NAV_WORKFLOW_CAP) break;
    const w = ordered.find((candidate) => candidate.key === key);
    if (w) chosen.add(w.id);
  }
  for (const w of ordered) {
    if (chosen.size >= NAV_WORKFLOW_CAP) break;
    chosen.add(w.id);
  }
  const current = ordered.find((w) => w.key === currentKey);
  if (current) chosen.add(current.id);
  return ordered.filter((w) => chosen.has(w.id));
}
